import { StarLite } from '@apeiron/star'
import { deserializeListData } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { starLiteSchema } from '@src/deserialize/yup/star'
import graphql from '@src/graphql/query/getStarByIDs'
import * as R from 'ramda'
import { useCallback, useState } from 'react'

export const useGetStarByIDs = (): Hook => {
  const [fetchStars, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<StarLite[]>([])

  const fetch = useCallback(
    async (starIDs: string[]): Promise<StarLite[]> => {
      if (R.isEmpty(starIDs)) {
        return []
      }

      const response = await fetchStars({
        variables: { starIDs, length: R.length(starIDs) }
      })

      const stars = deserializeListData<StarLite>(response, starLiteSchema)

      setData(stars)

      return stars
    },
    [fetchStars]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Hook = {
  data: StarLite[]
  loading: boolean
  fetch: (starIDs: string[]) => Promise<StarLite[]>
}
